module.exports = __webpack_public_path__ + "img/showcase-icon2.b716d2a7.png";